/**
 * Different Status for Page Component
 */
export enum Status {
  BeforeLoading,
  Loading,
  Loaded,
  LoadingFailed,
}
